import React, {PropTypes} from "react";
import {connect} from "react-redux";
import Modal from "react-bootstrap/lib/Modal";
import ExitTable from "./TeamExitTable";
import axios from "axios";
import ModalEdit from "../../hradmin/Exit/Modal";
import ModalDelete from "../VerticalSS/ModalExitView";
import ModalConfirm from "../ManagerSS/Modals/ModalConfirm";
import LoadingSpinner from "../../loadingSpinner";


function convertDate(employees) {
  let emp = new Array();
  employees.map((node)=> {
    if (node.doLeaving != null) {
      node.doL = new Date(node.doLeaving);

    }
    else
      node.doL = 'NA';
    if (node.doResignation != null) {
      node.doR = new Date(node.doResignation);

    }
    else node.doR = 'NA';

    if(node.imageUrl != null){
      const img = node.imageUrl;
      const img1 = img.replace("http",'https');
      const img2 = img1.substring(0,12) + "8" + img1.substring(12 + 1)
      node.imageUrl = img2;
    }
    else
      node.imageUrl = null;

    emp.push(node)
  })
  return emp;

}


class MyTeamExitHome extends React.Component {

  constructor() {
    super();
    this.state = {employees: [], employee: null, open: false, openDelete: false, disable: true, approve: false, loading:true}
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.edit = this.edit.bind(this);
    this.refresh = this.refresh.bind(this);
    this.trueDisable = this.trueDisable.bind(this);
    this.falseDisable = this.falseDisable.bind(this);
    this.closeApprove = this.closeApprove.bind(this);
    this.openApprove = this.openApprove.bind(this);

  }

  closeApprove() {
    this.setState({approve: false});
  }

  openApprove() {
    this.setState({approve: true});
  }

  trueDisable() {
    this.setState({disable: true})
  }

  falseDisable() {
    this.setState({disable: false})
  }

  open() {
    this.setState({open: true})
  }

  close() {
    this.setState({open: false})
  }

  edit(employee) {
    this.setState({employee: employee});
  }

  refresh() {
    axios.get(process.env.REQ_URL + "/exit/getExitsByManager", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {

      let employees = response.data.data;

      this.setState({employees: employees, loading: false})
    }).catch((err)=> {

    });
  }


  componentDidMount() {
    this.props.changeBanner("My Team - Exits");

    axios.get(process.env.REQ_URL + "/exit/getExitsByManager", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employees = response.data.data;

      this.setState({employees: employees, loading: false})
    }).catch((err)=> {

    });
  }


  render() {
    return (
      <div>

        {this.state.open ? <ModalEdit employee={this.state.employee}
                                      open={this.state.open}
                                      edit={this.edit}
                                      close={this.close}
                                      url={"/applyExit"}
                                      empRefresh={this.props.refresh}
                                      refresh={this.refresh}/> : null}
        {this.state.approve ? <ModalConfirm open={this.state.approve}
                                            employee={this.state.employee}
                                            close={this.closeApprove}
                                            refresh={this.refresh}
        /> : null}
        {this.state.openDelete ?
          <Modal

            bsSize="medium"
            show={this.state.openDelete} onHide={this.closeExit}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.employee.employeeCode} : {this.state.employee.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{borderStyle: 'solid', borderWidth: '0.5px'}}>
              <ModalDelete
                employee={this.state.employee}
                empRefresh={this.props.refresh}
                remove={this.props.remove}
                disabled={this.state.disable}
                open={this.state.openDelete}
                display="none"
                edit={this.edit}
                close={this.closeExit}
                refresh={this.refresh}
              />
              &nbsp;

            </Modal.Body>
          </Modal> : null}
          {this.state.loading ? <LoadingSpinner/> : <ExitTable
          trueDisable={this.trueDisable}
          falseDisable={this.falseDisable}
          edit={this.edit}
          openApprove={this.openApprove}
          open={this.open}
          openExit={this.openExit}
          refresh={this.refresh}
          employees={this.state.employees}/> }
      </div>
    );
  }

}

MyTeamExitHome.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    employee: state.emp[0]
  };
}

export default connect(mapStateToProps)(MyTeamExitHome);





/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/MyTeamExit/MyTeamExitHome.js
 **/